import { ElementType } from "../../../../library-js/dom-tools/ElementType";
import { OnChange, OnInput } from "../../../../library-js/dom-tools/EventListeners";

import { RJParser } from "../../../../library-js/rj/RJParser";

export class CalculatorBlock
{
  static readonly type = new ElementType( "calculator-block" );
  static readonly input = new ElementType( "calculator-input" );

  static readonly parser = new RJParser();

  static applyOnDocument()
  {
    CalculatorBlock.type.forAllInDoc( e => this.applyOnElement( e ) );
  }

  static applyOnElement( e:Element )
  {
  }
}